import { useDispatch, useSelector } from "react-redux";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { SearchIcon } from "@heroicons/react/outline";
import { playbackCamera, playbackSidebar } from "slice/playbackSlice";
import { LinearProgress } from "@mui/material";
import { getIpCamList } from "slice/ipCamSlice";
import { useEffect, useState } from "react";
import { getJurisdictionList } from "slice/jurisdictionSlice";
import ComponentN from "./playback/DataSidebar/ComponentN";
import ComponentNonN from "./playback/DataSidebar/ComponentNonN";
import { useDebounce } from "use-debounce";
import { getvideoList } from "slice/videoSlice";

const SidebarPlayback = () => {
  const dispatch = useDispatch();
  const { datavideoList, isLoadingvideoList } = useSelector(
    (state) => state.videoList.videoList
  );

  const [dataPlayback, setDataPlayback] = useState(datavideoList);
  const [isSorted, setIsSorted] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 2000);
  // console.log(isLoadingvideoList, "isLoadingvideoList");

  const toggleSort = () => {
    if (!isSorted) {
      // Saat belum di-sort, lakukan pengurutan
      const sortedData = [...datavideoList].sort((a, b) =>
        a.nama_video.localeCompare(b.nama_video)
      );
      setDataPlayback(sortedData);
    } else {
      // Saat sudah di-sort, kembalikan ke data awal
      setDataPlayback(datavideoList);
    }

    setIsSorted(!isSorted);
  };

  const handleClick = (item) => {
    dispatch(getIpCamList({ page: 0, size: 99, organizationId: item?.id }));
    dispatch(playbackSidebar(item));
  };
  const handleClickCamera = (item) => {
    dispatch(playbackCamera(item));
  };

  useEffect(() => {
    setDataPlayback(datavideoList);
  }, [datavideoList, debouncedSearch]);

  useEffect(() => {
    dispatch(
      getvideoList({
        page: 0,
        size: 99,
        keywords: debouncedSearch,
      })
    );
  }, [debouncedSearch, dispatch]);

  return (
    <div className="h-full">
      <div className="px-6 py-5">
        <div className="relative rounded-md shadow-sm">
          <input
            type="text"
            name="search"
            id="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="placeholder:italic block w-full pr-10 min-w-52 sm:text-sm border-gray-300 rounded-lg px-2 py-2 border text-black"
            placeholder="Search Camera"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
        </div>
      </div>

      <div className="w-full h-full text-white p-6 pt-2 flex flex-col relative">
        <div className="w-full flex justify-between gap-16 mb-4">
          <h3 className="text-sm font-semibold hidden md:block">
            List of Camera
          </h3>
          <div className="w-8 h-8 cursor-pointer" onClick={toggleSort}>
            {isSorted ? <FilterListIcon /> : <FilterListOffIcon />}
          </div>
        </div>

        <div className="w-full overflow-y-auto max-h-96">
          {isLoadingvideoList ? (
            <LinearProgress />
          ) : (
            <div className="">
              <ComponentNonN
                datavideoList={dataPlayback}
                handleClickCamera={handleClickCamera}
                handleClick={handleClick}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarPlayback;
